import apiClient from "../../services/apiClient";

// 학생 포인트 · 기프티콘 상점(api/reward). 학원 계정으로 부른다.
const BASE = "/api/v1/reward";

// 이 학원·유형의 기본값 { reward_points, min_score } (학원 관리 > 포인트 에서 정한 값)
export const fetchDefaultRewardRuleAPI = async (assignmentType) => {
  const response = await apiClient.get(`${BASE}/teacher/default-points?type=${encodeURIComponent(assignmentType)}`, { withAuth: true });
  return response.data;
};
// { rule_list, work_photo_bonus(수학 계정만) }
export const fetchRewardRuleListAPI = async () => (await apiClient.get(`${BASE}/teacher/rules`, { withAuth: true })).data;
export const saveRewardRuleListAPI = async (ruleList, workPhotoBonus) =>
  (
    await apiClient.put(
      `${BASE}/teacher/rules`,
      { rule_list: ruleList, ...(workPhotoBonus !== undefined ? { work_photo_bonus: workPhotoBonus } : {}) },
      { withAuth: true }
    )
  ).data;

// 상점을 켠 학원인가(기프티쇼 키 + 활성화 체크). 출제 창마다 부르지 않게 한 번만 묻는다.
let rewardOpenPromise = null;
export const fetchRewardOpenAPI = () => {
  if (!rewardOpenPromise) {
    rewardOpenPromise = apiClient
      .get(`${BASE}/teacher/default-points?type=`, { withAuth: true })
      .then((response) => Boolean(response.data.is_open))
      .catch(() => {
        rewardOpenPromise = null;
        return false;
      });
  }
  return rewardOpenPromise;
};
export const forgetRewardOpen = () => {
  rewardOpenPromise = null;
};

export const fetchRewardAccountAPI = async () => (await apiClient.get(`${BASE}/teacher/account`, { withAuth: true })).data;
export const saveRewardAccountAPI = async (body) => (await apiClient.put(`${BASE}/teacher/account`, body, { withAuth: true })).data;
export const refreshRewardBalanceAPI = async () => (await apiClient.post(`${BASE}/teacher/balance`, {}, { withAuth: true })).data;
// 기프티쇼 전체에서 60개씩. params: { q, brand, category, max_price, only(selected|recommended), page }
export const fetchAcademyRewardProductsAPI = async (params = {}) =>
  (await apiClient.get(`${BASE}/teacher/products`, { params, withAuth: true })).data;
export const selectAcademyRewardProductsAPI = async (productIdList, isSelected) =>
  (await apiClient.put(`${BASE}/teacher/products`, { product_id_list: productIdList, is_selected: isSelected }, { withAuth: true })).data;
// 그 브랜드 상품을 한 번에 올리거나 내린다
export const selectAcademyRewardBrandAPI = async (brandName, isSelected) =>
  (await apiClient.put(`${BASE}/teacher/products`, { brand: brandName, is_selected: isSelected }, { withAuth: true })).data;
// 본사 추천 상품을 한 번에 올린다
export const selectRecommendedRewardProductsAPI = async () =>
  (await apiClient.put(`${BASE}/teacher/products`, { recommended: true }, { withAuth: true })).data;
export const fetchAcademyRewardOrdersAPI = async () => (await apiClient.get(`${BASE}/teacher/orders`, { withAuth: true })).data;

export const fetchAdminRewardProductsAPI = async (params = {}) =>
  (await apiClient.get(`${BASE}/admin/products`, { params, withAuth: true })).data;
// patch: { is_hq_approved } 또는 { is_hq_hidden }
export const updateAdminRewardProductsAPI = async (productIdList, patch) =>
  (await apiClient.put(`${BASE}/admin/products`, { product_id_list: productIdList, ...patch }, { withAuth: true })).data;
export const updateAdminRewardBrandAPI = async (brandName, patch) =>
  (await apiClient.put(`${BASE}/admin/products`, { brand: brandName, ...patch }, { withAuth: true })).data;
// 모든 학원의 쿠폰 교환. userId 를 주면 그 학원만
export const fetchAdminRewardOrdersAPI = async (userId) =>
  (await apiClient.get(`${BASE}/admin/orders`, { params: userId ? { user_id: userId } : {}, withAuth: true })).data;

// 학원 관리 > 학생 목록의 포인트 칸. { is_open, balance_by_student_id }
export const fetchStudentPointBalancesAPI = async () =>
  (await apiClient.get(`${BASE}/teacher/student-points`, { withAuth: true })).data;
// amount 는 더하면 양수, 빼면 음수. { student_id, balance }
export const adjustStudentPointsAPI = async (studentId, amount, reason) =>
  (await apiClient.post(`${BASE}/teacher/student-points`, { student_id: studentId, amount, reason }, { withAuth: true })).data;
// 학생 포인트 한눈에. studentId 없으면 { student_list }, 있으면 그 학생 { history }
export const fetchStudentPointOverviewAPI = async (studentId) =>
  (await apiClient.get(`${BASE}/teacher/student-points/overview`, {
    params: studentId ? { student_id: studentId } : {},
    withAuth: true,
  })).data;
